import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ text = "Lade..." }) => {
  return (
    <div className="spinner-overlay">
      <div className="spinner-container"></div>
      <p className="spinner-text">{text}</p>
    </div>
  );
};

export default LoadingSpinner;
